<template>
  <ol>
    <slot />
  </ol>
</template>
<script>
export default {};
</script>
<style scoped>
ol {
  padding-left: 17px;
}
</style>
